<template>
  <router-view />
</template>

<route>
{
  "redirect": "/customer/settings/administrators",
  "name": "Customer Settings",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
import { mapActions } from "vuex";
export default {
  methods: mapActions("pageMeta", ["setPageTitle"]),
  created() {
    this.setPageTitle(this.$t("Settings"));
  },
};
</script>
